import { green } from '@mui/material/colors';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export const FORM_MODES = {
    add: "Add",
    edit: "Edit",
    renew: "Renew",
    view: "View"
};
export const EmailFrom = "NoReply@pilotcat.com";
export const EVENT_HEADER = [
    { id: 'eventName', label: 'Event Name', alignRight: false, sortId: 'eventName' },
    { id: 'eventLocation', label: 'Location', alignRight: false, sortId: 'eventLocation' },
    { id: 'client', label: 'Client', alignRight: false, sortId: 'client' },
    { id: 'eventStatus', label: 'Status', alignRight: false, sortId: 'eventStatus' },
    { id: 'eventDate', label: 'Start Date ', alignRight: false, sortId: 'eventDate' },
    { id: 'eventEndDate', label: 'End Date ', alignRight: false, sortId: 'eventEndDate' },
];

export const EVENT_USER_LIST_HEADER = [
    { field: 'firstName', headerName: 'First Name', flex: 1 },
    { field: 'lastName', headerName: 'Last Name', flex: 1 },
    { field: 'email', headerName: 'Email', flex: 2 },
    { field: 'phoneNumber', headerName: 'Phone', flex: 1 },
    { field: 'adjusterId', headerName: 'Pilot ID', flex: 1 },    
    {
        field: "existingUser",
        headerName: "In ERP",
        sortable: false,
        flex: 1,
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return (                                
                    params.value === true ? <CheckCircleIcon sx={{ color: green[400] }} /> : <ReportIcon />                            
            );
         }
      }
];
